/**
 * 小幫手「主動氣泡」的顯示規則（純述詞，不依賴 React 與 DOM）。
 *
 * 手機版的畫面寬度會讓氣泡跑出畫面外、關閉按鈕點不到，
 * 因此在手機寬度下關閉全部的主動彈出觸發；小幫手本體不受影響，
 * 使用者仍可主動點開。
 */

/** 主動氣泡的觸發來源 */
export type ProactiveBubbleTrigger =
  /** 生成完成事件（各生成頁面自行 dispatch 的 jodoni:generation:complete） */
  | 'generation-complete'
  /** 閒置達門檻後的自動彈出 */
  | 'idle';

/**
 * 手機版斷點（px），與專案 Tailwind 的 `md` 對齊。
 * Tailwind 的 `md:` 於 >= 768px 生效，故 768 本身視為桌機寬度。
 * 刻意採用 viewport 寬度而非 UA 偵測——桌機把視窗縮到很窄時會出現同樣的跑版。
 */
export const MOBILE_BREAKPOINT_PX = 768;

/**
 * 判定目前的畫面寬度是否屬於手機版。
 *
 * @param viewportWidth 目前的 viewport 寬度（px）
 */
export const isMobileViewport = (viewportWidth: number): boolean =>
  viewportWidth < MOBILE_BREAKPOINT_PX;

/** 手機版關閉的主動彈出觸發：兩個觸發都會冒出同一種氣泡、有同樣的跑版問題 */
const MOBILE_DISABLED_TRIGGERS: readonly ProactiveBubbleTrigger[] = [
  'generation-complete',
  'idle',
];

/**
 * 判定某個觸發是否應該顯示主動氣泡。
 *
 * 手機寬度下所有觸發一律不顯示；斷點（含）以上維持既有的桌機行為。
 *
 * @param viewportWidth 觸發當下的 viewport 寬度（px）
 * @param trigger 觸發來源
 * @returns 是否顯示氣泡
 */
export const shouldShowProactiveBubble = (
  viewportWidth: number,
  trigger: ProactiveBubbleTrigger,
): boolean => {
  if (isMobileViewport(viewportWidth) && MOBILE_DISABLED_TRIGGERS.includes(trigger)) return false;
  return true;
};
